import * as React from 'react';
import {Switch as RNSwitch, ViewStyle} from 'react-native';

import {withTheme} from '/provider/ThemeProvider';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './Switch.style';

interface SwitchProps {
  getTheme: (key: string) => {backgroundColor: string} | string;
  onToggleSwitch: (value: boolean) => void;
  isEnabled: boolean;
  isDisabled: boolean;
  style: ViewStyle;
  testID: string;
  accessibilityLabel: string;
}

export const Switch: React.FC<SwitchProps> = ({
  getTheme = () => ({backgroundColor: '#ccc'}), // Ensuring a valid return value
  onToggleSwitch = () => {},
  isEnabled = true,
  isDisabled = false,
  style = {},
  testID = '',
  accessibilityLabel = '',
}) => {
  const themeBackgroundColor =
    typeof getTheme('competency.backgroundColor') === 'string'
      ? getTheme('competency.backgroundColor')
      : (getTheme('competency.backgroundColor') as {backgroundColor: string})
          .backgroundColor;

  const background = {
    false: styles.track.backgroundColor,
    true: themeBackgroundColor,
  };

  return (
    <RNSwitch
      {...testProperties(testID)}
      style={[{...style}, {width: 64, height: 28}]}
      trackColor={background}
      thumbColor={styles.thumb.color}
      ios_backgroundColor={styles.track.backgroundColor}
      onValueChange={onToggleSwitch}
      disabled={isDisabled}
      value={isEnabled}
      accessibilityLabel={accessibilityLabel}
    />
  );
};

export default withHOC(withTheme)(Switch);
